function updateSearchSummary() {
    const summaryContainer = document.querySelector(
        ".wizzy-search-summary-container"
    );

    const searchedResponse = window.wizzyConfig?.pageStore?.searchedResponse;

    if (!summaryContainer || !searchedResponse) {
        return;
    }

    // If summary already exists, don't overwrite it
    if (summaryContainer.querySelector(".wizzy-summary-head")) {
        return;
    }

    const total = searchedResponse.total;
    const query = searchedResponse.filters?.q;
    if (total != null && query) {
        summaryContainer.innerHTML = `
            <p class="wizzy-summary-head">
                ${total} Results found for <strong>"${query}"</strong>:
            </p>
        `;
    }
}

window.onWizzyScriptLoaded = function() {

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
        data.search.configs.pagination.appendInExistingList = true;
        data.filters.configs.keepOpenedInMobileAfterApply = !0;
        data.autocomplete.configs.defaultBehaviour.suggestions.displayRecent = !0;
        return data;
    });
    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
        data.search.configs.pagination.appendInExistingList = true;
        data.filters.configs.keepOpenedInMobileAfterApply = !0;
        data.autocomplete.configs.defaultBehaviour.suggestions.displayRecent = !0;
        return data;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(products) {
        var upgradeSaleIds = (window.upgradeSaleProductIds || []).map(String);
        products.forEach((product) => {
            try {
                if (upgradeSaleIds.length > 0) {
                    var productId = String(product.groupId || product.singleVarientGroupId || '');
                    if (upgradeSaleIds.indexOf(productId) !== -1) {
                        var compareAtPrice = product.price > product.sellingPrice ? product.price : product.sellingPrice;
                        var newSellingPrice = Math.round(product.sellingPrice * 75 / 100);
                        product.price = compareAtPrice;
                        product.sellingPrice = newSellingPrice;
                        product.discountPercentage = Math.round((compareAtPrice - newSellingPrice) * 100 / compareAtPrice);
                    }
                }

            product.attributes.forEach((attr) => {
                if(attr.id === "product_subtitle_descriptors") {
                    product.hasSubtitle = true;
                    product.productSubtitle = attr.values[0].value[0];
                } else if(attr.id === "product_badge_judgeme") {
                    let divElement = document.createElement("div");
                    divElement.innerHTML = attr.values[0].value[0];
                    // console.log(divElement);
                    product.isOnCategory = window.wizzyConfig.common.isOnCategoryPage;
                    var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
                    var numberOfReviews = jdgmPrevBadge.getAttribute(
                        "data-number-of-reviews"
                    );
                    var review = jdgmPrevBadge.getAttribute("data-average-rating");
                    if (numberOfReviews > 0) {
                        product.numberOfReviews = numberOfReviews;
                        product.reviewAvailable = true;
                    } else {
                        product.reviewAvailable = false;
                    }
                    product.reviewData = attr.values[0].value[0];
                    product.avgRatings = parseFloat(parseFloat(review).toFixed(1));

                    product.reviewData = function () {
                        return function (text, render) {
                        return render(attr.values[0].value[0]);
                        };
                    };
                }
            })
            } catch (error) {
             console.log("Errr : ",error)   ;
            }
        })
        return products;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
       
        var closeButton = document.querySelector(".search__button.focus-inset[aria-label='Close']");
        if(closeButton) closeButton.click();
       
        return data;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function(data) {
      // console.log("BEFORE_FILTERS_EXECUTED : ",data);
      if(data.filters.type === "AUTOCOMPLETE_DEFAULT" && data.filters.sort && data.filters.sort[0].field === "relevance") {
        data.filters.sort.push({
              "field": "product_wizzy-best-selling_sortOrder:float",
              "order": "asc"
        });
      }
      return data;
    });

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
      function (data) {
        // console.log("BEFORE_AUTOCOMPLETE_RENDER",data);
        let otherSuggestions = data?.payload?.others;
        if(otherSuggestions) {
          otherSuggestions.forEach(otherSuggestion => {
            if(otherSuggestion.payload && otherSuggestion.payload.length > 0) {
              otherSuggestion.payload = otherSuggestion.payload.filter(payload => payload.key !== "relatedCategories")
            }
          });
        }
        setTimeout(syncAutocompleteWidth, 2); 
        try {
            const query = data.payload?.products?.filters?.q?.toLowerCase()?.trim();
            // Get mapped collections for the query
            var result = [];
            var mappedCollections = [];
            if(typeof window.getQueryCollections === "function") {
                mappedCollections = window.getQueryCollections(query);
            }
            // console.log(mappedCollections);
            if (mappedCollections !== 'undefined' && mappedCollections.length > 0) {
                result = mappedCollections.map(item => ({
                    value: item.title,
                    valueHighlighted: item.title,
                    // filters: {
                    //     categories: [item.handle]
                    // },
                    payload: [
                        { key: "parentId", value: ""},
                        // {key: "categoryId", value: item.handle},
                        {key: "categoryImage", value: ""},
                        {key: "relatedCategories",
                            value: [
                                {
                                    id: item.title,
                                    name: item.title,
                                    parentId: "",
                                    image: "",
                                    // url: `https://headsupfortails.com${item.url}`,
                                    // pathIds: [item.handle],
                                    description: "",
                                    suggestInOthers: true
                                }
                            ]
                        },
                        // {key: "isGlued",value: false}
                    ]
                }));

                if(data && data.payload && data.payload.others) {
                    data.payload.others = result;
                }
            }


            // data?.payload?.categories?.forEach(category => {
            //     category.payload.forEach(payloadItem => {
            //         if (payloadItem.key === "relatedCategories" && Array.isArray(payloadItem.value)) {
            //             payloadItem.value.forEach(relCat => {
            //                 if (typeof relCat.id === "string" && relCat.id.includes("_wzAc")) {
            //                     delete relCat.url;
            //                 }
            //             });
            //         }
            //     });
            // });
            
          } catch (error) {
              console.log(error);
          }
        return data;
      }
    );
    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {
        const resetButtons = document.querySelectorAll('.wizzy-facet-reset-button');
        updateSearchSummary();
    
        resetButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Find the parent facet block
                const facetBlock = this.closest('.wizzy-filters-facet-block');
                
                if (facetBlock) {
                    // Find all active list items within this facet block
                    const activeItems = facetBlock.querySelectorAll('.wizzy-facet-list-item.active');
                    
                    // Click on each active list item
                    activeItems.forEach(item => {
                        item.click();
                    });
                    
                    // Optional: Clear search input if exists
                    const searchInput = facetBlock.querySelector('.facet-head-search-input');
                    if (searchInput) {
                        searchInput.value = '';
                    }
                }
            });
        });
        return data;
    });
}

function syncAutocompleteWidth() {
  const searchBar = document.querySelector('.field.has-recommendation');
  const autoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

  if (searchBar && autoComplete) {
    const rect = searchBar.getBoundingClientRect();
    const width = searchBar.offsetWidth + 'px';
    const left = rect.left + 'px';
    
    document.documentElement.style.setProperty('--wizzy-autocomplete-width', width);
    document.documentElement.style.setProperty('--wizzy-autocomplete-left', left);
  }
}
document.body.addEventListener("click", function (event) {
    const target = event.target;
    if (target.matches(".field.has-recommendation")) {
      setTimeout(syncAutocompleteWidth, 100);      
    }
});
window.addEventListener('load', syncAutocompleteWidth);
window.addEventListener('resize', syncAutocompleteWidth);

const searchIcon =
  window.innerWidth < 768
    ? document.querySelector(
        "search-modal summary.header__icon"
      )
    : document.querySelector(
        "search-modal summary.header__icon"
      );


if (searchIcon) {
  searchIcon.addEventListener("click", (event) => {
    

   
      setTimeout(() => {
        const drawer = document.querySelector(
          ".search-modal__content"
        );
        const wizzyWrapper = document.querySelector(".wizzy-body-end-wrapper");
        if (drawer && wizzyWrapper) {
          drawer.appendChild(wizzyWrapper);
        }
      }, 1000);
    
    
  });
}

setTimeout(() => {
    const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.remove('wizzy-autocomplete-open');
  }
}

const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const observer = new MutationObserver(callback);
// console.log("target node : ",targetNode);
if (targetNode) {
  // console.log("Inside node condition : ",targetNode);
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
}
}, 1000);
// $(document).on('click', '.wizzy-body-end-wrapper,.autocomplete-text-wrapper', function(e) {
//   // Find the search-modal details element
//   const searchModal = $('search-modal details');
  
//   // Set the open attribute to true
//   searchModal.attr('open', 'true');
  
//   // Optional: Focus on the search input for better UX
//   setTimeout(function() {
//     $('.wizzy-search-input').focus();
//   }, 100);
// });